import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Highlighteable } from '../../../components/Text';
import theme from '../../../theme';

const RecipientInfo = ({ recipient }) => {
  const { t } = useTranslation();
  const darkgray = 'darkgray';

  if (!recipient) {
    return t('COMMON.MISSING');
  }

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column' }}>
      <span style={{ color: theme.color.primary, lineHeight: 1.2 }}>
        <Highlighteable
          content={recipient.name}
          search={recipient.name}
        />
      </span>
      {recipient.taxNumber && (
        <span style={{ lineHeight: 1.2 }}>
          <Highlighteable content={recipient.taxNumber} color={darkgray} />
        </span>
      )}
    </span>
  );
};

RecipientInfo.propTypes = {
  recipient: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    taxNumber: PropTypes.string,
  }),
};

RecipientInfo.defaultProps = {
  recipient: null,
};

export default RecipientInfo;
